"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Country = void 0;
const tslib_1 = require("tslib");
const errors_1 = require("@zap-onboard/errors");
const designed_1 = require("designed");
/**
 * n:   Country Name
 * a2:  Country Alpha 2 Code
 * a3:  Country Alpha 3 Code
 * num: Country Numeric Code
 * lat: Latitude (average)
 * lon: Longitude (average)
 */
const Country_json_1 = (0, tslib_1.__importDefault)(require("./Country.json"));
class Country {
    constructor(data) {
        this.data = data;
    }
    static fake() {
        return Country.byCode('AU').get();
    }
    static byCode(code) {
        return designed_1.Optional.of(Country_json_1.default.find((c) => c.a2 === code)).map((country) => new Country(country));
    }
    static by3CharacterCode(code) {
        return designed_1.Optional.of(Country_json_1.default.find((c) => c.a3 === code)).map((country) => new Country(country));
    }
    static fromName(name) {
        return designed_1.Optional.of(Country_json_1.default.find((c) => c.n === name))
            .map((country) => new Country(country))
            .orThrow(() => errors_1.errs.ValidationError.create(`${name} is not a valid country name`));
    }
    static options() {
        return Country_json_1.default.map((c) => ({ name: c.n, value: c.a2 }));
    }
    static fromJSON(s) {
        if (typeof s !== 'string') {
            throw errors_1.errs.UnexpectedError.create('Country was given a non string value');
        }
        return Country.byCode(s).orThrow(() => errors_1.errs.ValidationError.create(`${s} is not a valid country code`));
    }
    static isValid(s) {
        return Country.validationMessage(s) == null;
    }
    static validationMessage(s) {
        try {
            Country.fromJSON(s);
            return undefined;
        }
        catch (e) {
            if (e instanceof errors_1.errs.ValidationError) {
                return e.message;
            }
            throw errors_1.errs.UnexpectedError.wrap(e);
        }
    }
    toString() {
        return this.data.a2;
    }
    asJSON() {
        return this.data.a2;
    }
    get alpha2Code() {
        return this.data.a2;
    }
    get name() {
        return this.data.n;
    }
}
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], Country, "options", null);
exports.Country = Country;
